import React from "react"

class SearchBox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...props
    }

    this.search = this.search.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  search() {
    this.props.doSearch(this.searchInput.value)
  }

  render() {
    const { query } = this.state

    return(
      <input 
        type="text"
        id="search-loans"
        ref={input => {this.searchInput = input}}
        placeholder="Search My Loans"
        value={query}
        onChange={this.search}/>
    )
  }
}

export default SearchBox;
